/**
 * Labstep
 *
 * @module components/Resource/Action/Delete
 * @desc Action to delete
 */

import { EntityActionDelete } from 'labstep-web/components/Entity/Action/Delete';
import type React from 'react';
import type { IResourceActionDeleteProps } from './types';

export const ResourceActionDelete: React.FC<
  IResourceActionDeleteProps
> = ({ resource, ...rest }) => (
  <EntityActionDelete
    dataCy="components/Resource/Action/Delete"
    {...rest}
    entity={resource}
  />
);
